module.exports = __webpack_public_path__ + "media/rolling-footage.834220c7.mp4";